// Mock data for Yunere landing page

export const mockWaitlistSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock waitlist submission:', formData);
      resolve({
        success: true,
        message: 'Successfully joined the waitlist!',
        data: { id: `mock_${Date.now()}`, ...formData }
      });
    }, 1000);
  });
};

export const mockResources = [
  {
    id: 1,
    type: 'blog',
    title: 'The Hidden Costs of Manual CAM Reconciliations',
    description: 'Discover how manual processes are costing your business time, money, and tenant relationships.',
    date: '2024-03-15',
    readTime: '5 min read',
    image: 'https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg',
    content: `Manual CAM reconciliations create hidden costs that many property managers overlook. Beyond the obvious hours spent on spreadsheets and lease reviews, there are real impacts on cash flow, tenant trust, and team morale.

When reconciliations drag on for weeks or months, delays in billing mean delayed recovery of operating expenses. That gap can strain budgets and create uncertainty for both landlords and tenants. Manual processes also increase the risk of calculation errors, which can lead to disputes, refunds, and damaged relationships.

Tenants today expect transparency and speed. Lengthy reconciliation cycles and opaque calculations erode confidence. Property managers who automate CAM reconciliation with tools like Yunere report faster closeouts, fewer disputes, and stronger tenant satisfaction. The investment in better processes pays off in reduced hidden costs and improved operations.`
  },
  {
    id: 2,
    type: 'case-study',
    title: 'How ABC Properties Reduced CAM Time by 80%',
    description: 'A mid-size property manager shares their transformation story from weeks to days.',
    date: '2024-03-10',
    readTime: '8 min read',
    image: 'https://images.pexels.com/photos/1029606/pexels-photo-1029606.jpeg',
    content: `ABC Properties manages a portfolio of commercial buildings totaling over 500,000 square feet. Their CAM reconciliation process used to take three to four weeks per property, with staff manually extracting lease terms, building spreadsheets, and reconciling against general ledger data.

After implementing an automated CAM reconciliation platform, ABC cut that timeline to under five days. Lease terms are now parsed automatically, allocation rules are applied consistently, and reports are generated with full audit trails. The team reallocated saved time to tenant communication and dispute prevention instead of data entry.

Key results: 80% reduction in time spent on reconciliations, zero calculation errors in the first year, and significantly fewer tenant questions thanks to clear, defensible reports. ABC's finance lead says the ROI was visible within the first quarter.`
  },
  {
    id: 3,
    type: 'blog',
    title: 'Understanding CAM Reconciliation: A Complete Guide',
    description: 'Everything property managers need to know about CAM reconciliations in 2024.',
    date: '2024-03-05',
    readTime: '10 min read',
    image: 'https://images.pexels.com/photos/8439093/pexels-photo-8439093.jpeg',
    content: `CAM (Common Area Maintenance) reconciliation is the process of comparing actual operating expenses for shared spaces against what tenants were billed during the year, then settling the difference. It's a core responsibility for commercial property managers and can be one of the most time-consuming and error-prone tasks.

A typical reconciliation involves: gathering lease documents and understanding each tenant's CAM terms; collecting actual expense data from the general ledger; allocating expenses according to lease language (e.g., by square footage, pro-rata share); preparing a reconciliation report; and billing or crediting tenants. Manual steps—especially lease reading and allocation—are where delays and mistakes often occur.

In 2024, best practice is to leverage technology that reads leases, applies allocation rules, and produces audit-ready reports. This reduces cycle time, improves accuracy, and gives property managers more time for tenant relations and strategic work. Understanding CAM reconciliation is the first step; streamlining it with the right tools is the next.`
  }
];

export const mockFeatures = [
  {
    icon: 'Clock',
    title: 'Save Weeks of Work',
    description: 'Close CAM reconciliations in days instead of weeks or months. Automated lease reading eliminates manual data entry.'
  },
  {
    icon: 'Target',
    title: 'Pinpoint Accuracy',
    description: 'Eliminate calculation errors with AI-powered lease interpretation and expense allocation based on exact lease terms.'
  },
  {
    icon: 'Shield',
    title: 'Dispute-Proof Reports',
    description: 'Generate defensible CAM summaries with complete audit trails. Confidently respond to tenant questions.'
  },
  {
    icon: 'FileText',
    title: 'Smart Lease Parsing',
    description: 'Automatically extract CAM terms, square footage, and allocation rules from any lease format (PDF/DOCX).'
  },
  {
    icon: 'Database',
    title: 'Seamless Data Import',
    description: 'Import rent rolls and GL exports directly. Compare data across sources to catch discrepancies instantly.'
  },
  {
    icon: 'TrendingUp',
    title: 'Actionable Insights',
    description: 'Get clear visibility into expense allocation, recovery rates, and potential disputes before they happen.'
  }
];

export const mockTestimonials = [
  {
    name: 'Sarah Chen',
    role: 'Property Manager',
    company: 'Metro Commercial Properties',
    quote: 'Yunere transformed our CAM process.  What used to take 3 weeks now takes 2 days. Our tenants appreciate the faster turnaround too.',
    avatar: 'SC'
  },
  {
    name: 'Michael Rodriguez',
    role: 'Owner',
    company: 'Rodriguez Real Estate Group',
    quote: 'The defensibility feature is a game-changer. We have not had a single CAM dispute since implementing Yunere.',
    avatar: 'MR'
  }
];

export const mockStats = [
  { value: '80%', label: 'Time Saved' },
  { value: '99.9%', label: 'Accuracy Rate' },
  { value: '500K+', label: 'SF Managed' },
  { value: '0', label: 'Disputes' }
];
